module.exports = __webpack_public_path__ + "img/gear-blue.ab910ca0.svg";